module.exports = __webpack_public_path__ + "img/vertical_6_7_9016.bf99aa79.png";